import {Component, Input} from '@angular/core';

@Component({
  selector: 'ds-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss']
})
export class InputErrorComponent {

  @Input() error = {message: '', iconClass: ''};
  @Input() showError = false;
  @Input() id = 'form-error-message';
}
